import type { Property } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  property: Property;
};

function formatLocation(p: Property): string {
  const cs = [p.address.city, p.address.state].filter(Boolean).join(", ");
  return cs || p.address.zip || "";
}

export function createSelectPropertyCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { property, id = `select-property:done:${property.id.toString()}` } = props;
  const location = formatLocation(property);
  return {
    id,
    category: "negotiate",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="negotiate"
        badge="Price"
        title={property.address.addressLine1}
        details={{
          title: "Selected property",
          children: (
            <div className="flex flex-col gap-1">
              <p className="font-medium">{property.address.addressLine1}</p>
              {location ? <p className="opacity-70">{location}</p> : null}
            </div>
          ),
        }}
      />
    ),
  };
}
